// extracted by mini-css-extract-plugin
export default {"TechDetails":"TechDetails_TechDetails__R3V3r","noLink":"TechDetails_noLink__Fmc2I"};